import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import RoleAccessLayer from "../../components/RoleAccessLayer";
import DescargasLayer from "../../components/comprobantes/DescargasLayer";

const Descargas = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Descargas" />

        {/* RoleAccessLayer */}
        <DescargasLayer/>

      </MasterLayout>

    </>
  );
};

export default Descargas; 
